import styled from '@emotion/styled';
import AttenderA from '@assets/svg/attender_a.svg';
import {colors} from '@styles/colors';
import {fontWeight, mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import {a} from 'react-spring';
import { keyframes } from '@emotion/css';

const pulse = keyframes`
	0% {
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
	}

	70% {
		box-shadow: 0 0 0 7px rgba(255, 255, 255, 0);
	}

	100% {
		box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
	}
`

export const MenuWrap = styled(a.div)`
  position: fixed;
  top: 0;
  right: 0px;
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background-color: ${colors.red};
  z-index: 227;
  will-change: translate;
  /* border-radius: 30px 0 0 30px; */

  ${mq(Devices.laptop)} {
    width: 50vw;
    max-width: unset;
  }

  ${mq(Devices.tablet)} {
    left: 0;
    width: var(--document-width);
  }
`;

export const AppVer = styled.span`
  position: absolute;
  color: ${colors.white};
  font-weight: ${fontWeight.medium};
  left: 90px;
  top: 30px;
  display:flex;
  flex-direction: column;
  
  span{
    :nth-of-type(1){
      font-size: 16px;
      line-height: 16px;
    }
    :nth-of-type(2){
      font-size: 10px;
      line-height: 16px;
      font-weight: ${fontWeight.regular};
    }
  }

  ${mq(Devices.tablet)} {
    left: 11vw;
  }
`;

export const MenuContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  padding: 10px;
  top: 21px;
  right: calc(var(--padding) - 10px);

  svg {
    margin: auto;
    width: 20px;
    fill: ${colors.white};
    transform: rotate(45deg);
  }

  ${mq(Devices.tablet)} {
    top: 21px;
    /* right: 0; */
    /* left: var(--padding); */
  }
`;

export const MenuItems = styled.nav`
  display: flex;
  flex-direction: column;
  margin-top: 13.67vh;
  padding-left: 90px;
  padding-right: 90px;
  padding-bottom: 2.04vw;
  width: 100%;
  z-index: 20;

  a:nth-of-type(n + 2) {
    margin-top: 15px;
  }

  ${mq(Devices.tablet)} {
    margin-top: 23.91vh;
    padding-left: 11vw;
    padding-right: 11vw;
    padding-bottom: 11vw;
  }
`;

export const MenuItem = styled.a<{ active: boolean }>`
  display:flex;
  gap:12px;
  align-items: center;
  font-size: 24px;
  --wght: ${(props) => (props.active ? fontWeight.bold : fontWeight.light)};
  font-weight: var(--wght);
  color: ${colors.white};
  text-align: left;
  cursor: pointer;
  transition: 0.2s font-weight;
  will-change: font-weight;

  ${mq(Devices.tablet)} {
    font-size: 20px;
  }

  ${mq(Devices.mobile)} {
    font-size: 6vw;
  }

  &:hover {
    --wght: ${(props) => (props.active ? fontWeight.bold : fontWeight.regular)};
  }
`;

export const Backdrop = styled(AttenderA)`
  position: absolute;
  bottom: 0;
  right: -1.5vw;
  opacity: 0.2;
  width: 70%;
  z-index: 1;

  ${mq(Devices.tablet)} {
    width: 50vw;
  }

  path {
    fill: ${colors.white};
  }
`;


export const NoteficationCount = styled.div`
  /* position: absolute; */
  background:#fff;
  color:#fb4856;
  display: flex;
  align-items:center;
  justify-content: center;
  height:20px;
  width:20px;
  /* top: 50%;
  left: -35px ; */
  font-size: 12px;
  font-weight: 600;
  /* transform: translateY(-50%);  */
  border-radius: 50%;
  animation: ${pulse} 1.4s linear infinite;
`;
